import { render, staticRenderFns } from "./menu5_images_scence_q.vue?vue&type=template&id=5b64214b&scoped=true"
import script from "./menu5_images_scence_q.vue?vue&type=script&lang=js"
export * from "./menu5_images_scence_q.vue?vue&type=script&lang=js"
import style0 from "./menu5_images_scence_q.vue?vue&type=style&index=0&id=5b64214b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64214b",
  null
  
)

export default component.exports